export const hiddenParticipants: TableModule = {
    name: "hiddenParticipants",
    route: "spa.events.events.hiddenParticipants",
    routeParams: [{
        param: "event",
        prop: "event_id"
    }],
    defaultOrder: {
        column: "lastname",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            mobile: true
        },
        {
            name: "gender",
            mobile: true,
            sortable: true,
            width: 'w-[120px]',
        },
        {
            name: "address",
            sortable: true,
            sortBy: "participants.zip",
        },
        {
            name: "communications"
        }
    ],
    filters: [
        {
            name: "id",
            column: "participants.id",
            type: "numeric"
        },
        {
            name: "firstname",
            column: "participants.firstname",
            type: "string"
        },
        {
            name: "lastname",
            column: "participants.lastname",
            type: "string",
            reduced: true
        },
        {
            name: "birthday",
            column: "participants.birthday",
            type: "date",
            reduced: "date[,]"
        },
        {
            name: "gender",
            column: "participants.gender",
            type: "select",
            options: () => ['m', 'f', 'd'].map((option) => ({
                value: option,
                label: useNuxtApp().$i18n.t(`genders.${option}`)
            }))
        },
        {
            name: "street",
            column: "participants.street",
            type: "string"
        },
        {
            name: "house_number",
            column: "participants.house_number",
            type: "string"
        },
        {
            name: "zip",
            column: "participants.zip",
            type: "string",
            reduced: true
        },
        {
            name: "city",
            column: "participants.city",
            type: "string"
        },
        {
            name: "email",
            column: "participants.email",
            type: "string"
        },
    ],
    quickFilters: [],
    tools: [

    ]
}